import React, {useContext} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import getObjectValue from "libs/getObjectValue";


function OrderTermsData(
    {
        id,
        formikProps
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)


    return (<>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("variantsAllowed")}
            required
        />

        <Collapse in={gVal("variantsAllowed") === true}>

            <NoticeGlossaryInput
                formikProps={formikProps}
                id={gId("variantsAllowedInfo")}
                items={getDict("SL.MO.019")}
                required
            />

        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("auctionPlanned")}
            required
        />

        <Collapse in={gVal("auctionPlanned") === true}>

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("auctionUrl")}
                required
            />

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("auctionPlannedInfo")}
                required
                multiline
            />

        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("guaranteeRequired")}
        />

        <Collapse in={gVal("guaranteeRequired") === true}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("guaranteeRequiredInfo")}
                multiline
                required
            />
        </Collapse>

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("properExecutionGuarantee")}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("togetherRequirements")}
            multiline
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("possibleDemandInvalidation")}
            required
        />

    </>)
}

OrderTermsData.propTypes = {};

export default OrderTermsData;
